/**
 * Rota guardada no log de erros (`nucleo_erros.rota`), a mesma regra na web e no servidor (correções de 02/11, ROB-M1, ROB-M2,
 * SPEC-B2, SEG-B1, SEG-B2): sai todo parâmetro de texto digitado (busca da lista, busca da lixeira), `voltar` e `lado` (carregam
 * outra rota, com a busca dentro; `lado` é o painel 2 da tela dividida, rtd-9) e segredo de link (`token`, `code`, `state`). Os demais filtros ficam, porque ajudam a reproduzir.
 * O nome do parâmetro é lido já decodificado, então `%62usca=` também sai.
 */
const PARAMETRO_DE_TEXTO = /^(busca|q|termo|search|nome|email|e-mail|telefone|documento|cpf|cnpj|lx_q|voltar|lado|token|code|state)$/i;

/** O teto do CHECK da coluna `rota` (migration 0332). */
export const TETO_ROTA_LOG = 300;

/** A busca (`?a=1`) sem os parâmetros de texto; `valor` limpa o que sobrar, já decodificado. */
export function semParametrosDeTexto(search: string, valor: (v: string) => string = (v) => v): string {
  const saida = new URLSearchParams();
  for (const [k, v] of new URLSearchParams(search)) if (!PARAMETRO_DE_TEXTO.test(k)) saida.append(valor(k), valor(v));
  const r = saida.toString();
  return r ? `?${r}` : '';
}

/** Corta no teto sem deixar um escape pela metade: o servidor recodificaria o `%` solto e passaria do CHECK. */
export const cortarRotaDoLog = (rota: string) => rota.slice(0, TETO_ROTA_LOG).replace(/%[0-9a-f]?$/i, '');

/** A rota inteira (caminho e busca) sem os parâmetros de texto e sem fragmento, cortada no teto. */
export function rotaDoLog(rota: string, valor: (v: string) => string = (v) => v): string {
  // O token do convite fica no caminho (rcorr-2): é segredo de link, como `token` na busca.
  const semFragmento = (rota.split('#', 1)[0] ?? '').replace(/^(\/convite\/)[^/?]+/, '$1:token');
  const i = semFragmento.indexOf('?');
  if (i < 0) return cortarRotaDoLog(valor(semFragmento));
  return cortarRotaDoLog(valor(semFragmento.slice(0, i)) + semParametrosDeTexto(semFragmento.slice(i), valor));
}
